import { useParams } from 'react-router-dom';
import {
    BooleanInput,
    EditBase,
    SimpleForm,
    TextInput,
    useEditContext,
} from 'react-admin';
import { Box, Card } from '@mui/material';

import { HelpDocumentAside } from './HelpDocumentAside';

// Reads :id from the nested Settings route; resource/redirect are explicit
// because this isn't mounted as a react-admin Resource at /help_documents.
export const HelpDocumentEdit = () => {
    const { id } = useParams();
    return (
        <EditBase
            resource="help_documents"
            id={id}
            mutationMode="pessimistic"
            redirect="/settings/help-knowledge"
        >
            <HelpDocumentEditContent />
        </EditBase>
    );
};

const HelpDocumentEditContent = () => {
    const { isPending, record } = useEditContext();
    if (isPending || !record) return null;

    return (
        <Box mt={2} display="flex">
            <HelpDocumentAside />
            <Box flex="1">
                <Card>
                    <SimpleForm>
                        <TextInput source="title" fullWidth />
                        <TextInput source="kind" disabled fullWidth />
                        <TextInput source="source_filename" disabled fullWidth />
                        <TextInput
                            source="content"
                            multiline
                            fullWidth
                            minRows={12}
                            maxRows={20}
                        />
                        <BooleanInput source="is_active" />
                    </SimpleForm>
                </Card>
            </Box>
        </Box>
    );
};
